<template>
  <div>
    <v-layout
      v-if="voucher.item"
      row
      align-center
    >
      <v-flex xs10>
        <span :style="myTitleStyle">{{ voucher.name }}</span>
      </v-flex>
      <v-flex
        xs2
        class="text-xs-right"
        :style="myPriceStyle"
      >
        {{ $n(voucher.item.price, 'currency') }}
      </v-flex>
    </v-layout>
    <div
      v-if="voucher.image"
      class="mt-2 text-xs-center"
    >
      <img
        :src="voucher.image"
        style="width: 100%; height: auto;"
      />
    </div>
    <v-divider
      :color="theme.menu_category_border_color"
      class="mt-2 mb-2"
    />
    <div>
      <div
        class="note"
        :style="mySubTitleStyle"
        v-html="voucher.gems_member_voucher.Description"
      >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    voucher: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme'
    ]),
    ...mapGetters('menu', [
      'menuItem'
    ]),
    myTitleStyle () {
      return {
        color: this.theme.menu_title_color
      }
    },
    mySubTitleStyle () {
      return {
        fontSize: '16px',
        color: this.theme.menu_subtitle_color
      }
    },
    myPriceStyle () {
      return {
        color: this.theme.menu_price_color
      }
    },
    myQtyStyle () {
      return {
        color: this.theme.menu_qty_color
      }
    },
    myItemStyle () {
      return {
        color: this.theme.menu_color
      }
    },
    noteStyle1 () {
      return {
        fontWeight: 400,
        fontSize: 'smaller',
        color: this.theme.text_disabled_color
      }
    },
    noteStyle2 () {
      return {
        fontWeight: 400,
        fontSize: 'smaller',
        color: this.theme.text_enabled_color
      }
    },
    voucherItems () {
      if (this.voucher) {
        const items = Array.isArray(this.voucher.items) ? this.voucher.items : JSON.parse(this.voucher.items)
        return items.map(id => {
          return this.promotionItems.find(item => item.item_id === id)
        })
      }
      return []
    }
  }
}
</script>

<style scoped>
.note {
  font-weight: 400;
  font-size: smaller;
  color: grey;
}
.title {
  margin-bottom: 8px;
}
.option {
  margin-top: -32px;
}
</style>



// WEBPACK FOOTER //
// src/components/VoucherDetail.vue